<template>
  <div>
    <h6 class="font-weight-medium">Online Account Login</h6>
    <div v-for="user in users" :key="user.id">
      <div
        data-testid="sp-online-account-email"
        class="d-flex justify-space-between flex-wrap"
      >
        <div class="d-inline-block text-truncate">{{ user.email }}</div>
        <SoCopyToClipboard :plain-text="user.email">
          <template #button="{ copyToClipboard }">
            <SoButton
              type="sidebar-icon"
              icon="copy sm"
              @click="copyToClipboard"
            />
          </template>
        </SoCopyToClipboard>
      </div>
      <div
        v-if="hasDrift(user)"
        class="d-flex align-center mb-2"
        data-testid="sp-online-account-email-drift"
      >
        <div
          class="bg-warning rounded text-body-2 py-1 px-2 d-flex align-center ga-1"
        >
          <SoIcon
            icon="alert-circle"
            size="x-small"
            class="d-flex align-center"
          />
          Differs from primary contact email
        </div>
      </div>
    </div>
    <div
      v-if="!users.length && !isLoading"
      data-testid="sp-online-account-none"
      class="text-medium-emphasis"
    >
      No online account
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IUser } from "@/models/admin/user/user.types"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoCopyToClipboard from "@/components/SoCopyToClipboard.vue"
  import SoIcon from "@/components/SoIcon.vue"

  export default defineComponent({
    components: {
      SoButton,
      SoCopyToClipboard,
      SoIcon,
    },
    props: {
      users: {
        type: Array as PropType<IUser[]>,
        default: () => [],
      },
      primaryContactEmail: {
        type: String as PropType<string | null>,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      // be-identity treats login emails case-insensitively (lower(email) index,
      // equalIgnoreCase lookups), so a case-only difference is not real drift.
      normalise(email: string | null): string {
        return (email ?? "").trim().toLowerCase()
      },
      hasDrift(user: IUser): boolean {
        const contactEmail = this.normalise(this.primaryContactEmail)
        if (!contactEmail) return false
        return this.normalise(user.email) !== contactEmail
      },
    },
  })
</script>
